import { TREATMENT_COHORTS } from './useSimplifiedNavNewUsers.ts';

type UseSimplifiedNavSpotlightParams = {
	/** Global menu items from useMenuItems. Used to determine if Recent is in main nav. */
	globalMenuItems: ReadonlyArray<{ menuId: string }>;
	/** From usePlatformCustomizationsWithSimplifyNav. Avoids duplicate useSimplifiedNavNewUsers call. */
	navStyle: string;
	/** From usePlatformCustomizationsWithSimplifyNav. Avoids duplicate useSimplifiedNavNewUsers call. */
	isWithinD0: boolean;
};

export type UseSimplifiedNavSpotlightResult = {
	/** Show spotlight when Recent in main nav, treatment, and D1+. Use to gate rendering. */
	shouldShowSpotlight: boolean;
	/** Persist "opened customize" when Recent in main nav and treatment (includes D0). Use for setHasOpenedCustomize gate so D0 users who open customize don't see spotlight when they become D1+. */
	shouldPersistCustomizeOpen: boolean;
};

/**
 * Determines spotlight eligibility and persist gates (ACTIVATION-2059).
 * Pass navStyle and isWithinD0 from usePlatformCustomizationsWithSimplifyNav to avoid duplicate onboarding state calls.
 */
export const useSimplifiedNavSpotlight = ({
	globalMenuItems,
	navStyle,
	isWithinD0,
}: UseSimplifiedNavSpotlightParams): UseSimplifiedNavSpotlightResult => {
	const isRecentInMainNav = globalMenuItems.some((item) => item.menuId === 'recent');
	const isEligibleForSpotlight = isRecentInMainNav && TREATMENT_COHORTS.has(navStyle);

	return {
		shouldShowSpotlight: isEligibleForSpotlight && !isWithinD0,
		shouldPersistCustomizeOpen: isEligibleForSpotlight,
	};
};
